import { Box } from '@mui/system'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Paper, Typography } from '@mui/material'

export const About = () => {
	return (
		<Box>
			<Box
				sx={{
					color: 'grey',
					display: 'flex',
					alignItems: 'center',
				}}
			>
				<InfoOutlinedIcon
					sx={{
						fontSize: '44px',
						margin: '2px 22px',
					}}
				/>
				<Typography variant="config_header">About</Typography>
			</Box>
			<Box
				sx={{
					display: 'flex',
				}}
			>
				<Paper
					elevation={3}
					sx={{
						width: '400px',
						height: '200px',
						margin: '22px',
						color: '#707070',
						padding: '20px 40px',
					}}
				>
					<Typography
						sx={{
							fontSize: '24px',
							fontWeight: '600',
						}}
					>
						Version
					</Typography>
					<Typography
						sx={{
							fontSize: '16px',
						}}
					>
						v2.2.8
					</Typography>
				</Paper>
				<Paper
					elevation={3}
					sx={{
						width: '400px',
						height: '200px',
						margin: '22px',
						color: '#707070',
						padding: '20px 40px',
					}}
				>
					<Typography
						sx={{
							fontSize: '24px',
							fontWeight: '600',
						}}
					>
						Contact us
					</Typography>
					<Typography
						sx={{
							fontSize: '16px',
						}}
					>
						Phone: (+852) 2312 6880
						<br />
						Email: enquiry@varadise.cloud
					</Typography>
				</Paper>
			</Box>
		</Box>
	)
}
